webpackJsonp([70144966829960],{

/***/ 628:
/***/ (function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ]
	
	    var isDataView = function(obj) {
	      return obj && DataView.prototype.isPrototypeOf(obj)
	    }
	
	    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
	      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	    }
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	    } else if (Array.isArray(headers)) {
	      headers.forEach(function(header) {
	        this.append(header[0], header[1])
	      }, this)
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var oldValue = this.map[name]
	    this.map[name] = oldValue ? oldValue+','+value : value
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    name = normalizeName(name)
	    return this.has(name) ? this.map[name] : null
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = normalizeValue(value)
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    for (var name in this.map) {
	      if (this.map.hasOwnProperty(name)) {
	        callback.call(thisArg, this.map[name], name, this)
	      }
	    }
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsArrayBuffer(blob)
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsText(blob)
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf)
	    var chars = new Array(view.length)
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i])
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength)
	      view.set(new Uint8Array(buf))
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (!body) {
	        this._bodyText = ''
	      } else if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer)
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer])
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body)
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      }
	    }
	
	    this.text = function() {
	      var rejected = consumed(this)
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	
	    if (input instanceof Request) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = String(input)
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, { body: this._bodyInit })
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers()
	    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
	    // https://tools.ietf.org/html/rfc7230#section-3.2
	    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ')
	    preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
	      var parts = line.split(':')
	      var key = parts.shift().trim()
	      if (key) {
	        var value = parts.join(':').trim()
	        headers.append(key, value)
	      }
	    })
	    return headers
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = options.status === undefined ? 200 : options.status
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = 'statusText' in options ? options.statusText : 'OK'
	    this.headers = new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init)
	      var xhr = new XMLHttpRequest()
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        }
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      } else if (request.credentials === 'omit') {
	        xhr.withCredentials = false
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ }),

/***/ 327:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  max-width: ', ';\n  margin: 0 auto;\n  display: flex;\n  flex-flow: row wrap;\n  justify-content: space-between;\n  align-items: flex-start;\n  input,\n  textarea {\n    font-family: inherit;\n    font-size: inherit;\n    border: none;\n    outline: none;\n    background: ', ';\n    color: ', ';\n    border-radius: 2px;\n    padding: 1em;\n    &::-webkit-input-placeholder {\n      color: gray;\n    }\n    &::-moz-placeholder {\n      color: gray;\n    }\n    &:-ms-input-placeholder {\n      color: gray;\n    }\n    &:-moz-placeholder {\n      color: gray;\n    }\n    &:required {\n      box-shadow: none;\n    }\n    &:focus {\n      outline: none;\n    }\n  }\n  &::before {\n    content: \'\';\n    background: black;\n    height: 100%;\n    width: 100%;\n    position: fixed;\n    top: 0;\n    left: 0;\n    z-index: 1;\n    transition: 0.2s all;\n    opacity: ', ';\n    visibility: ', ';\n  }\n'], ['\n  max-width: ', ';\n  margin: 0 auto;\n  display: flex;\n  flex-flow: row wrap;\n  justify-content: space-between;\n  align-items: flex-start;\n  input,\n  textarea {\n    font-family: inherit;\n    font-size: inherit;\n    border: none;\n    outline: none;\n    background: ', ';\n    color: ', ';\n    border-radius: 2px;\n    padding: 1em;\n    &::-webkit-input-placeholder {\n      color: gray;\n    }\n    &::-moz-placeholder {\n      color: gray;\n    }\n    &:-ms-input-placeholder {\n      color: gray;\n    }\n    &:-moz-placeholder {\n      color: gray;\n    }\n    &:required {\n      box-shadow: none;\n    }\n    &:focus {\n      outline: none;\n    }\n  }\n  &::before {\n    content: \'\';\n    background: black;\n    height: 100%;\n    width: 100%;\n    position: fixed;\n    top: 0;\n    left: 0;\n    z-index: 1;\n    transition: 0.2s all;\n    opacity: ', ';\n    visibility: ', ';\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  margin: 0 0 1em 0;\n  width: 100%;\n  @media (min-width: ', ') {\n    width: 49%;\n  }\n'], ['\n  margin: 0 0 1em 0;\n  width: 100%;\n  @media (min-width: ', ') {\n    width: 49%;\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  width: 100%;\n  margin: 0 0 1em 0;\n  line-height: 1.6;\n  min-height: 250px;\n  resize: vertical;\n'], ['\n  width: 100%;\n  margin: 0 0 1em 0;\n  line-height: 1.6;\n  min-height: 250px;\n  resize: vertical;\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  background: ', ' !important;\n  color: white !important;\n  cursor: pointer;\n  transition: 0.2s;\n  &:hover {\n    background: ', ' !important;\n  }\n'], ['\n  background: ', ' !important;\n  color: white !important;\n  cursor: pointer;\n  transition: 0.2s;\n  &:hover {\n    background: ', ' !important;\n  }\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n  background: white;\n  padding: 2em;\n  border-radius: 2px;\n  position: fixed;\n  min-width: 75%;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  margin: 0 auto;\n  z-index: 99;\n  display: flex;\n  flex-flow: column;\n  align-items: flex-start;\n  transition: 0.2s all;\n  opacity: ', ';\n  visibility: ', ';\n  @media screen and (min-width: ', ') {\n    min-width: inherit;\n    max-width: 400px;\n  }\n  p {\n    line-height: 1.6;\n    margin: 0 0 2em 0;\n  }\n'], ['\n  background: white;\n  padding: 2em;\n  border-radius: 2px;\n  position: fixed;\n  min-width: 75%;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  margin: 0 auto;\n  z-index: 99;\n  display: flex;\n  flex-flow: column;\n  align-items: flex-start;\n  transition: 0.2s all;\n  opacity: ', ';\n  visibility: ', ';\n  @media screen and (min-width: ', ') {\n    min-width: inherit;\n    max-width: 400px;\n  }\n  p {\n    line-height: 1.6;\n    margin: 0 0 2em 0;\n  }\n']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n  background: ', ';\n  font-size: 1em;\n  display: inline-block;\n  margin: 0 auto;\n  border: none;\n  outline: none;\n  cursor: pointer;\n  color: white;\n  padding: 1em;\n  border-radius: 2px;\n  text-decoration: none;\n  transition: 0.2s;\n  z-index: 99;\n  &:focus {\n    outline: none;\n  }\n  &:hover {\n    background: ', ';\n  }\n'], ['\n  background: ', ';\n  font-size: 1em;\n  display: inline-block;\n  margin: 0 auto;\n  border: none;\n  outline: none;\n  cursor: pointer;\n  color: white;\n  padding: 1em;\n  border-radius: 2px;\n  text-decoration: none;\n  transition: 0.2s;\n  z-index: 99;\n  &:focus {\n    outline: none;\n  }\n  &:hover {\n    background: ', ';\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(11);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	__webpack_require__(628);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	// Fetch Polyfill
	
	/*
	  ⚠️ This is an example of a contact form powered with Netlify form handling.
	  Be sure to review the Netlify documentation for more information:
	  https://www.netlify.com/docs/form-handling/
	*/
	
	var Form = _styledComponents2.default.form(_templateObject, function (props) {
	  return props.theme.sizes.maxWidthCentered;
	}, function (props) {
	  return props.theme.colors.tertiary;
	}, function (props) {
	  return props.theme.colors.base;
	}, function (props) {
	  return props.overlay ? '.8' : '0';
	}, function (props) {
	  return props.overlay ? 'visible' : 'hidden';
	});
	
	var Name = _styledComponents2.default.input(_templateObject2, function (props) {
	  return props.theme.responsive.small;
	});
	
	var Email = _styledComponents2.default.input(_templateObject2, function (props) {
	  return props.theme.responsive.small;
	});
	
	var Message = _styledComponents2.default.textarea(_templateObject3);
	
	var Submit = _styledComponents2.default.input(_templateObject4, function (props) {
	  return props.theme.colors.base;
	}, function (props) {
	  return props.theme.colors.highlight;
	});
	
	var Modal = _styledComponents2.default.div(_templateObject5, function (props) {
	  return props.visible ? '1' : '0';
	}, function (props) {
	  return props.visible ? 'visible' : 'hidden';
	}, function (props) {
	  return props.theme.responsive.small;
	});
	
	var Button = _styledComponents2.default.div(_templateObject6, function (props) {
	  return props.theme.colors.base;
	}, function (props) {
	  return props.theme.colors.highlight;
	});
	
	var encode = function encode(data) {
	  return Object.keys(data).map(function (key) {
	    return encodeURIComponent(key) + '=' + encodeURIComponent(data[key]);
	  }).join('&');
	};
	
	var ContactForm = function (_React$Component) {
	  _inherits(ContactForm, _React$Component);
	
	  function ContactForm(props) {
	    _classCallCheck(this, ContactForm);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.handleInputChange = function (event) {
	      var _this$setState;
	
	      var target = event.target;
	      var value = target.value;
	      var name = target.name;
	      _this.setState((_this$setState = {}, _this$setState[name] = value, _this$setState));
	    };
	
	    _this.handleSubmit = function (event) {
	      fetch('/', {
	        method: 'POST',
	        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	        body: encode(_extends({ 'form-name': 'contact' }, _this.state))
	      }).then(_this.handleSuccess).catch(function (error) {
	        return alert(error);
	      });
	      event.preventDefault();
	    };
	
	    _this.handleSuccess = function () {
	      _this.setState({
	        name: '',
	        email: '',
	        message: '',
	        showModal: true
	      });
	    };
	
	    _this.closeModal = function () {
	      _this.setState({ showModal: false });
	    };
	
	    _this.state = {
	      name: '',
	      email: '',
	      message: '',
	      showModal: false
	    };
	    return _this;
	  }
	
	  ContactForm.prototype.render = function render() {
	    return _react2.default.createElement(
	      Form,
	      {
	        name: 'contact',
	        onSubmit: this.handleSubmit,
	        'data-netlify': 'true',
	        'data-netlify-honeypot': 'bot',
	        overlay: this.state.showModal,
	        onClick: this.closeModal
	      },
	      _react2.default.createElement('input', { type: 'hidden', name: 'form-name', value: 'contact' }),
	      _react2.default.createElement(
	        'p',
	        { hidden: true },
	        _react2.default.createElement(
	          'label',
	          null,
	          'Don\u2019t fill this out:',
	          ' ',
	          _react2.default.createElement('input', { name: 'bot', onChange: this.handleInputChange })
	        )
	      ),
	      _react2.default.createElement(Name, {
	        name: 'name',
	        type: 'text',
	        placeholder: 'Full Name',
	        value: this.state.name,
	        onChange: this.handleInputChange,
	        required: true
	      }),
	      _react2.default.createElement(Email, {
	        name: 'email',
	        type: 'email',
	        placeholder: 'Email',
	        value: this.state.email,
	        onChange: this.handleInputChange,
	        required: true
	      }),
	      _react2.default.createElement(Message, {
	        name: 'message',
	        type: 'text',
	        placeholder: 'Message',
	        value: this.state.message,
	        onChange: this.handleInputChange,
	        required: true
	      }),
	      _react2.default.createElement(Submit, { name: 'submit', type: 'submit', value: 'Send' }),
	      _react2.default.createElement(
	        Modal,
	        { visible: this.state.showModal },
	        _react2.default.createElement(
	          'p',
	          null,
	          'Thank you for reaching out. I will get back to you as soon as possible.'
	        ),
	        _react2.default.createElement(
	          Button,
	          { onClick: this.closeModal },
	          'Okay'
	        )
	      )
	    );
	  };
	
	  return ContactForm;
	}(_react2.default.Component);
	
	ContactForm.propTypes = {
	  data: _propTypes2.default.object
	};
	
	exports.default = ContactForm;
	module.exports = exports['default'];

/***/ }),

/***/ 337:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(45);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _siteConfig = __webpack_require__(47);
	
	var _siteConfig2 = _interopRequireDefault(_siteConfig);
	
	var _Container = __webpack_require__(69);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _ContactForm = __webpack_require__(327);
	
	var _ContactForm2 = _interopRequireDefault(_ContactForm);
	
	var _SEO = __webpack_require__(100);
	
	var _SEO2 = _interopRequireDefault(_SEO);
	
	var _PageBody = __webpack_require__(99);
	
	var _PageBody2 = _interopRequireDefault(_PageBody);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Contact = function Contact(_ref) {
	  var data = _ref.data;
	
	  var postNode = {
	    title: 'Contact - ' + _siteConfig2.default.siteTitle
	  };
	  var snippet = data.snippet.body;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        'Contact - ' + _siteConfig2.default.siteTitle
	      )
	    ),
	    _react2.default.createElement(_SEO2.default, { postNode: postNode, pagePath: 'contact', customTitle: true }),
	    _react2.default.createElement(
	      _Container2.default,
	      null,
	      _react2.default.createElement(_PageBody2.default, { body: snippet }),
	      _react2.default.createElement(_ContactForm2.default, null)
	    )
	  );
	};
	
	var query = exports.query = '** extracted graphql fragment **';
	
	exports.default = Contact;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contact-js-21aeb805df63a8578694.js